"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.SortButtonStyle = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "em75g8f0"
} : {
  target: "em75g8f0",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;justify-self:", props.justify, ";font-size:14px;align-items:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const SortButtonStyle = active => /*#__PURE__*/(0, _react.css)("font-weight:600;opacity:", active ? '1' : '0.5', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:SortButtonStyle;"));
exports.SortButtonStyle = SortButtonStyle;